import React from "react";
import { useMemo, useCallback } from "react";

import { LESSON_CONTENTS } from "../../../../constants/active_learning";
import { IActiveLearningAnswers } from "../../../../state";
import { Context, updateActiveLearningAnswers } from "../../../../studentStore";
import Header from "../../../../organisms/ActiveLearning/Header";
import EndLesson from "../../../../organisms/ActiveLearning/EndLesson";
import MyData from "../../../../organisms/student/ActiveLearningLessonsMyData";
import Issue1 from "../../../../organisms/student/ActiveLearningLessons/Lesson12/Issue1";
import Issue2 from "../../../../organisms/student/ActiveLearningLessons/Lesson12/Issue2";
import Issue3 from "../../../../organisms/student/ActiveLearningLessons/Lesson12/Issue3";
import styles from "../ActiveLearningLesson.module.scss";
import useWaitApiCall from "../../../../hooks/useWaitApiCall";
import SaveAnswerButton from "../../../../atoms/ActiveLearning/SaveAnswerButton";

export const Lesson = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [answers, setAnswers] = React.useState<IActiveLearningAnswers[]>([]);

  React.useEffect(() => {
    setAnswers([...state.active_learning_answers]);
  }, [state.active_learning_answers]);

  const currentActiveLearning = useMemo(() => {
    return state.active_learning_data_by_lesson;
  }, [state.active_learning_data_by_lesson]);

  const findIssue = useCallback(
    (no: number) =>
      currentActiveLearning.issues?.find(issue => issue.no === no),
    [currentActiveLearning],
  );

  const saveAnswers = () => {
    const params = answers;
    const { material_code, no } = state.active_learning_data_by_lesson;
    if (calling) return;
    return dispatch(
      peep(
        updateActiveLearningAnswers(material_code, no, JSON.stringify(params)),
      ),
    );
  };

  const getThemeId = useCallback(
    ({
      lessonNo,
      issueNo,
      questionNo,
    }: {
      lessonNo: number;
      issueNo: number;
      questionNo: number;
    }): number => {
      const themeId = state.active_learning_answers_by_material
        .find(answer => answer.lesson_no === lessonNo)
        ?.issues.find(i => i.issue_no === issueNo)
        ?.questions.find(q => q.question_no === questionNo)?.answers[0]
        ?.contents.theme_id;
      return themeId || 0;
    },
    [state.active_learning_answers_by_material],
  );

  return (
    <div className={styles.wrapper} id="accordion">
      {/* <p>answer: {JSON.stringify(answers)}</p> */}
      <Header
        no={currentActiveLearning.no}
        label={LESSON_CONTENTS.lesson12.label}
        title={currentActiveLearning.title}
        read={LESSON_CONTENTS.lesson12.read}
      />
      <div className={styles.container}>
        <div className={styles.section}>
          <Issue1
            issue={findIssue(1)}
            answers={answers}
            setAnswers={setAnswers}
            themeId={getThemeId({ lessonNo: 1, issueNo: 2, questionNo: 1 })}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <Issue2
            issue={findIssue(2)}
            answers={answers}
            setAnswers={setAnswers}
            themeId={getThemeId({ lessonNo: 1, issueNo: 2, questionNo: 1 })}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <Issue3
            issue={findIssue(3)}
            answers={answers}
            setAnswers={setAnswers}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <EndLesson
            text={LESSON_CONTENTS.lesson12.end}
            saveAnswers={saveAnswers}
          />
        </div>
      </div>
      <MyData />
    </div>
  );
};
export default Lesson;
